exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.apexcharts-canvas[data-v-0005e5d2] {\n  max-height: 300px !important;\n}\n", ""]);

// exports
